exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".asseco-floaty-btn{position:relative;width:56px;height:56px;float:right;cursor:pointer;background-color:#303f9f;border-radius:50%;box-shadow:0 4px 8px rgba(0,0,0,.25);z-index:1000}.asseco-floaty-btn:hover{opacity:.9}.asseco-floaty-btn-icon{transition:all .2s;width:24px;height:24px}.asseco-floaty-btn-icon path{fill:#fff}", ""]);

// exports
